import React from 'react';
import { NavLink } from 'react-router-dom';
import { guestNav } from '../../data/config';
import { useLanguage } from '../../context/LanguageContext';
import { useTenantBase, toTenantPath } from '../../lib/tenantPath';

// Renders the guest navigation links relative to the current tenant base
// (/s/:slug, /g/:token or /paelbi). `variant` switches header vs mobile style.
export function GuestNavLinks({ variant = 'desktop', onNavigate }) {
  const { t } = useLanguage();
  const base = useTenantBase();
  const className = ({ isActive }) =>
    variant === 'desktop'
      ? `font-sans text-[15px] transition-colors hover:text-paelbi-brown ${isActive ? 'text-paelbi-brown font-semibold' : 'text-paelbi-ink/80'}`
      : `border-b border-paelbi-line/60 py-3 font-sans text-[15px] ${isActive ? 'text-paelbi-brown font-semibold' : 'text-paelbi-ink/80'}`;

  return guestNav.map((item) => {
    const to = toTenantPath(item.path, base);
    return (
      <NavLink key={item.path} to={to} end={to === base} onClick={onNavigate} className={className}>
        {t(item.label)}
      </NavLink>
    );
  });
}

export default GuestNavLinks;
